import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const sessionSteps = [
  { icon: 'ri-hand-heart-line', label: 'Boas-vindas guiada' },
  { icon: 'ri-brain-line', label: 'Explicação simples sobre o sistema nervoso' },
  { icon: 'ri-headphone-line', label: 'Áudio terapêutico psicoeducativo' },
  { icon: 'ri-mental-health-line', label: 'Indução profunda de regulação' },
  { icon: 'ri-seedling-line', label: 'Exercício da semana' },
];

const WA_LINK = 'https://wa.me/5521990212845?text=Ol%C3%A1,%20gostaria%20de%20iniciar%20minha%20sess%C3%A3o%20gratuita%20do%20M%C3%A9todo%20Equilibradamente.';

export default function WhatHappensSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-24 px-6" style={{ background: '#0B1525' }}>
      <div
        ref={ref}
        className="max-w-3xl mx-auto"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(28px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        <div className="text-center mb-14">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-6 border"
            style={{ background: 'rgba(0,200,232,0.08)', color: '#00C8E8', borderColor: 'rgba(0,200,232,0.2)' }}
          >
            Estrutura da sessão
          </span>
          <h2 className="text-3xl md:text-4xl font-semibold text-white">
            O que acontece na primeira sessão
          </h2>
        </div>

        <div className="flex flex-col items-center gap-0">
          {sessionSteps.map((step, i) => (
            <div key={step.label} className="flex flex-col items-center w-full max-w-md">
              <div
                className="flex items-center gap-5 w-full rounded-2xl px-6 py-5 border"
                style={{
                  background: '#0F1E30',
                  borderColor: 'rgba(0,200,232,0.12)',
                  opacity: visible ? 1 : 0,
                  transform: visible ? 'scale(1)' : 'scale(0.95)',
                  transition: `opacity 0.5s ease ${i * 0.1}s, transform 0.5s ease ${i * 0.1}s`,
                }}
              >
                <span
                  className="w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0"
                  style={{ background: 'rgba(0,200,232,0.1)' }}
                >
                  <i className={`${step.icon} text-lg`} style={{ color: '#00C8E8' }} />
                </span>
                <p className="text-base font-medium" style={{ color: '#B8D4E8' }}>{step.label}</p>
              </div>
              {i < sessionSteps.length - 1 && (
                <div className="w-px h-4" style={{ background: 'rgba(0,200,232,0.2)' }} />
              )}
            </div>
          ))}
        </div>

        <p className="text-center text-sm mt-8" style={{ color: '#5A7A95' }}>
          Duração aproximada: 15 minutos.
        </p>

        {/* WhatsApp CTA */}
        <div className="flex justify-center mt-8">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 whitespace-nowrap font-semibold rounded-full px-9 py-4 text-base cursor-pointer"
            style={{
              background: 'linear-gradient(135deg, #25D366, #1DB954)',
              color: '#FFFFFF',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-2px)';
              (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 8px 28px rgba(37,211,102,0.40)';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
              (e.currentTarget as HTMLAnchorElement).style.boxShadow = 'none';
            }}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </span>
            Quero começar minha sessão gratuita
          </a>
        </div>
      </div>
    </section>
  );
}